<template>
  <div class="box-img">
    <el-carousel
      :autoplay="true"
      :style="{ height: mydata.carouselH + 'px !important' }"
      @change="handleElCcarouselChange"
    >
      <el-carousel-item
        v-for="item in mydata.slideArr.length === 0
          ? props.initSlideArr
          : mydata.slideArr"
        :key="item.id"
      >
        <div class="box-cards">
          <slot name="qwe"> </slot>
          <a href="javascript:void(0)" @click="aClick(item.extend)">
            <img
              v-if="item.image.includes('slideDefault')"
              :src="item.image"
              alt=""
              :width="props.imgWidth"
              :height="props.imgHeight"
              class="box-cards-img"
            />
            <img
              v-else
              v-complete:src="item.image"
              alt=""
              :width="props.imgWidth"
              :height="props.imgHeight"
              class="box-cards-img"
            />
          </a>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup>
import { nextTick, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
// 获取这个页面的轮播图数组
import { getSlideArr } from "@/utils/slide.js";
const route = useRoute();
const router = useRouter();
// console.log("route", route.path);

const props = defineProps({
  // 默认的轮播图数组
  initSlideArr: {
    type: Array,
    default: () => {
      return [
        {
          id: "默认值",
          image: require("@/assets/slideDefault.png"),
        },
      ];
    },
  },
  // 图片宽度
  imgWidth: {
    type: String,
    default: "100%",
  },
  // 图片高度
  imgHeight: {
    type: String,
    default: "200px",
  },
  // 图片宽度
  path: {
    type: String,
    default: "",
  },
});

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // 后端返回的轮播图数组
  // slideArr: getSlideArr(route.path),
  slideArr: [],
  carouselH: 0, //轮播图的默认高度
  currentIndex: 0, //轮播图的默认展示图片的下标
});

function fn() {
  if (props.path === "") {
    mydata.slideArr = getSlideArr(route.path);
  } else {
    mydata.slideArr = getSlideArr(props.path);
  }
}
fn();

function aClick(path) {
  if (!path) {
    return;
  }
  // // 如果是完整地址，那么先分割成数组再进行跳转；如果不是完整地址，那么直接跳转
  // if (
  //   path.includes("http://") ||
  //   path.includes("https://") ||
  //   path.includes("#")
  // ) {
  //   router.push({ path: path.split("#")[1] });
  // } else {
  //   router.push({ path: path });
  // }
 // 获取#符号后面的所有内容
  let fullPath = path.split("#").slice(-1)[0]
  // console.log(fullPath);
  // 如果存在查询参数
  if(fullPath.includes("?")){
    // 单纯路径
    let purePath =  fullPath.split("?")[0]
    // console.log(purePath);
    // 参数数组
    let queryArr = fullPath.split("?").slice(-1)[0].split("&")
    // console.log(queryArr);
    // 参数对象
    let queryObj = {}
    queryArr.forEach((item)=>{
      let key = item.split("=")[0]
      let val = item.split("=")[1]
      queryObj[key]=val
    })
    // console.log(queryObj);
    // 跳转地址
    router.push({ path: purePath,query:queryObj });
  }else{
    router.push({ path: fullPath });
  }
}

// 设置轮播图高度
function setCarouselHeight(currentIndex) {
  // 获取当前展示的图片元素
  let eleImg = document.getElementsByClassName("box-cards-img")[currentIndex];
  // 监听图片元素加载完毕事件（必须监听事件，否则获取不到图片元素的高度）
  eleImg.onload = () => {
    // 获取图片元素高度
    mydata.carouselH = eleImg.clientHeight;
    // 取消监听图片元素的加载事件（必须取消监听，否则每一次调用这个函数的时候都会给图片元素添加一个监听事件，导致监听事件一直累加）
    eleImg.onload = null;
  };
}

// 轮播图的图片切换事件
function handleElCcarouselChange(currentIndex) {
  // 获取当前正在展示的图片元素的下标
  mydata.currentIndex = currentIndex;
  // 调用函数-设置轮播图高度
  setCarouselHeight(mydata.currentIndex);
}

onMounted(() => {
  nextTick(() => {
    // 初始化调用函数-设置轮播图高度
    setCarouselHeight(mydata.currentIndex);
  });
});
</script>

<style scoped lang="scss">
.box-img {
  width: 100%;

  // height: 200px; // 注释了，这里不要写固定高度
  //   border: 1px solid red;
  > slot {
    width: 100%;
    // height: 600px;
    // border:1px solid rgb(68, 0, 255);
    margin: 0 auto;
  }
}

//el-carousel元素
:deep(.el-carousel__container) {
  width: 100%;
  height: 200px;
}


// 轮播图的图片元素的样式
.box-cards-img {
  width: 100% !important;
  height: auto;
}
// 轮播图本身的样式
:deep(.el-carousel) {
  transition: height 0.2s linear;
}
</style>
